import { useCallback, useEffect, useState } from 'react';

export function useTestimonials(count) {
  const [slide, setSlide] = useState(0);
  const [perView, setPerView] = useState(1);

  useEffect(() => {
    const update = () => {
      if (window.matchMedia('(min-width: 1024px)').matches) setPerView(3);
      else if (window.matchMedia('(min-width: 640px)').matches) setPerView(2);
      else setPerView(1);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const pageCount = Math.max(1, Math.ceil(count / perView));

  useEffect(() => {
    setSlide((s) => Math.min(s, pageCount - 1));
  }, [pageCount]);

  const goSlide = useCallback(
    (i) => {
      setSlide(((i % pageCount) + pageCount) % pageCount);
    },
    [pageCount]
  );

  useEffect(() => {
    const timer = window.setInterval(() => {
      setSlide((s) => (s + 1) % pageCount);
    }, 6500);
    return () => window.clearInterval(timer);
  }, [pageCount]);

  return { slide, perView, pageCount, goSlide, setSlide };
}
